import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
function FormFillupDetails({  }) {
  const links = new Set();
  const navigate = useNavigate();
 
    {
      links.add({ path: "/allowresubmission", label: "ALLOW RESUBMISSION" });    
      links.add({ path: "/submittedformfillupcsvreport", label: "DOWNLOAD FORMFILLUP CSV" });
      links.add({ path: "/attendancesheet", label: "ATTENDANCE SHEET" });  
       links.add({ path: "/newregistrationcsv", label: "DOWNLOAD NEW REGISTRATION CSV" });      
    } 
   
  const handleGoBack = () => {
    navigate(`/`); 
  };

  return (
     <main className="w-full">
         <div className="flex flex-col items-center w-full">


         <div className="w-full bg-red-100 relative py-1">
            {/* Absolute Positioned Button */}
            <button  onClick={handleGoBack}  className="absolute top-1.5 left-1.5 bg-red-500 text-white px-4 py-2 rounded-lg shadow-md hover:bg-red-600 transition duration-300 text-xs">
              BACK
            </button>

            {/* Heading */}
            <h1 className="text-2xl  text-gray-400 text-center"> FORM FILLUP REPORTS</h1>
            <p className="w-full text-center font-semibold text-xs text-transparent">(The form is autosave)</p>    
          </div>

    

      <div className="flex flex-wrap justify-center gap-4 mt-4">
        {[...links].map((link, index) => (
          <Link key={index} to={link.path}>
            <div className="w-[150px] h-[150px] bg-gradient-to-r from-blue-400 to-blue-200 text-gray-800 p-2 rounded-lg shadow-lg hover:from-blue-700 hover:to-blue-400 hover:text-white transition-all cursor-pointer flex items-center justify-center text-center text-xs">
              {link.label}
            </div>
          </Link>
        ))}
      </div>
      </div>
    </main>
  );
}

export default FormFillupDetails;
